<template>
    <div class="kpi-item buttoncomment">
        <div class="commentinput">
            <el-input
                :disabled="disabled"
                type="textarea"
                @blur="$emit('update:suggestion', suggestion)"
                v-model="localSuggestion"
                placeholder="上级评语及建议"
                :rows="3"
            />
        </div>
        <div class="topnum">
            <div class="score-board">
                <div class="score-card">
                    <div class="score-title">总分值</div>
                    <div class="score-number">100</div>
                </div>
                <div class="score-card">
                    <div class="score-title">自评总分</div>
                    <div class="score-number">{{ selfTotalScore || 0 }}</div>
                </div>
                <div class="score-card">
                    <div class="score-title">终评总分</div>
                    <div class="score-number">{{ finalScore || 0 }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { ElInput } from "element-plus";

const props = defineProps({
    suggestion: { type: String, default: "" },
    selfTotalScore: { type: [Number, String], default: 0 },
    finalScore: { type: [Number, String], default: 0 },
    disabled: { type: Boolean, default: false }
});

const emit = defineEmits(["update:suggestion"]);

const localSuggestion = ref(props.suggestion);
watch(
    () => props.suggestion,
    (v) => {
        localSuggestion.value = v;
    }
);
watch(localSuggestion, (v) => {
    emit("update:suggestion", v);
});
</script>

<style lang="scss" scoped>
.buttoncomment {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: stretch;
    background: #fff;
    border-radius: 10px;
    padding: 10px 12px;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
    border: 1px solid #e8eaed;

    .topnum {
        width: 34%;
        min-width: 280px;
        background: #f9fafc;
        border: 1px solid #ebeff5;
        border-radius: 8px;
        padding: 6px;
    }

    .commentinput {
        width: 66%;
        :deep(.el-textarea) {
            display: block;
        }
        :deep(.el-textarea__inner) {
            min-height: 60px !important;
            border-radius: 8px;
            padding: 10px 12px;
            line-height: 1.5;
            border: 1px solid #e5e7eb;
            box-shadow: none;
            transition:
                border-color 0.2s ease,
                box-shadow 0.2s ease;
        }
        :deep(.el-textarea__inner:focus) {
            border-color: #93c5fd;
            box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.08);
        }
    }

    .score-board {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 6px;
        height: 100%;
    }

    .score-card {
        border: 1px solid #e6ebf2;
        border-radius: 8px;
        background: #fff;
        padding: 8px 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .score-title {
        font-size: 12px;
        color: #000;
        margin-bottom: 4px;
    }

    .score-number {
        font-size: 24px;
        font-weight: 700;
        line-height: 1;
        color: #000;
    }
}

@media (max-width: 1200px) {
    .buttoncomment {
        flex-direction: column;
        align-items: stretch;

        .topnum,
        .commentinput {
            width: 100%;
            min-width: 0;
        }
    }
}

@media (max-width: 768px) {
    .buttoncomment .score-board {
        grid-template-columns: 1fr;
    }
}
</style>
